import { render } from "./TextareaField.vue?vue&type=template&id=3225ed7a"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TextareaField.vue"]])

export default __exports__